/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { IntersectionAnimation } from "~components";
import * as Slices from "~slices";

const SanitySlice = (props) => {
  const { data } = props;

  const { _type: sliceType } = data; // e.g. colorBlockHeaderSlice

  if (!sliceType) {
    // eslint-disable-next-line no-console
    console.error(
      `Please pass a _type from your template to the Section component`
    );

    return null;
  }

  const sliceName =
    sliceType[0].toUpperCase() + sliceType.slice(1, sliceType.length); // e.g. ColorBlockHeader

  const Slice = Slices[sliceName];

  if (!Slice) {
    // eslint-disable-next-line no-console
    console.error(
      `Can't find Slice "${sliceName}", are you sure it exists in the sections directory?`
    );

    return null;
  }

  const componentsWithNoIntersectionAnimation = [
    `HomepageAtf`,
    `ContactBlock`,
    `TextMarqueeSlice`
  ];

  if (
    componentsWithNoIntersectionAnimation.includes(sliceName) ||
    data.renderIndex === 0
  ) {
    return <Slice {...props} />;
  }

  return (
    <IntersectionAnimation>
      <Slice {...props} />
    </IntersectionAnimation>
  );
};

export default SanitySlice;
